import PropTypes from 'prop-types'

import CarfaxIconListItem from './carfax-icon-list-item.js'
import {BASE_CLASS} from './config.js'

const CarfaxServiceVerifiedDataContentList = ({contentList}) => {
  return (
    <ul className={`${BASE_CLASS}-serviceContentList`}>
      {contentList.map(({text, value}, index) => (
        <CarfaxIconListItem key={index} text={text} type={value} />
      ))}
    </ul>
  )
}

CarfaxServiceVerifiedDataContentList.displayName = 'CarfaxServiceVerifiedDataContentList'
CarfaxServiceVerifiedDataContentList.propTypes = {
  contentList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string
    })
  )
}

export default CarfaxServiceVerifiedDataContentList
